module.exports = __webpack_public_path__ + "img/fb.9c059b4a.png";